import React, { useEffect, useState } from "react"
import { Modal, ModalBody, Button, ModalHeader, ModalFooter, Alert } from "reactstrap"
import SpinnerWrap from "../SpinnerWrap"
import "./submitCancelModal.scss"

const SubmitCancelModal = ({
    isOpen,
    closeModal,
    handleSubmit,
    modalTitle,
    children,
    alertColor = "",
    alertMessage = "",
    submitButtonText = "SUBMIT",
    showConfirmLoading,
    submitButtonTextLoading = "SUBMITTING",
    className = ""
}) => {
    return (
        <Modal
            isOpen={isOpen}
            fade={true}
            centered={true}
            toggle={() => !showConfirmLoading && closeModal()}
            className={"submit-cancel-modal " + className}
        >
            <ModalHeader className="title-center" toggle={() => !showConfirmLoading && closeModal()}>
                {modalTitle}
            </ModalHeader>
            <ModalBody>{children}</ModalBody>
            <ModalFooter className="modal-footer-wrap">
                <Alert color={alertColor} isOpen={!!alertMessage}>
                    {alertMessage}
                </Alert>

                <div className="modal-footer-submit-cancel">
                    <Button onClick={handleSubmit} color="primary" type="submit" disabled={showConfirmLoading}>
                        <SpinnerWrap
                            showSpinner={showConfirmLoading}
                            txtTrue={submitButtonTextLoading}
                            txtFalse={submitButtonText}
                            disabled={showConfirmLoading}
                        />
                    </Button>{" "}
                    <Button onClick={closeModal} type="button" disabled={showConfirmLoading}>
                        CANCEL
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default SubmitCancelModal
